let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("9gFtJ")).then(() => parcelRequire('hM1vX'));